import axios from 'axios'
import { CONSTANT } from '../../../utils/constant'

export const AXIOS_SHARED = axios.create({
  baseURL: CONSTANT.MASTERPASS_URL
})
